
import { useNavigate } from "react-router-dom";
import { Checkbox, Chip, Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useCarritoItemsStore } from "../../../stores";
import { fechaSinHora } from "../../../helpers/prepararFecha";


const paginado = Number(process.env.REACT_APP_PAGINADO);



export const TablaItemsPorTrabajar = ({ selected, handleSelectAllClickUser, handleClick, isSelected, data, chagePage=null, page=0 }) => {


    const navigate = useNavigate();
    const { totalItems } = useCarritoItemsStore();
    

    return (

        <>
        {(data?.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalItems / +paginado)} disabled={Math.ceil(totalItems / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox" style={{ padding:1, width:'5%'}}>
                            <Checkbox color="secondary"
                                indeterminate={ selected.length > 0 && selected.length < data.length }
                                checked={ data.length > 0 && selected.length === data.length }
                                onChange={ handleSelectAllClickUser }
                            />
                        </TableCell>
                        <TableCell sx={{width:'15%'}}>Entrega</TableCell>
                        <TableCell sx={{width:'10%'}}>O.P.</TableCell>
                        <TableCell sx={{width:'20%'}}>Producto</TableCell>
                        <TableCell sx={{width:'20%'}}>Cliente</TableCell>
                        <TableCell sx={{width:'15%'}}>Estado</TableCell>
                        <TableCell sx={{width:'15%'}}>Pago</TableCell>
                        <TableCell sx={{width:'10%'}}>Opcion</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data.map( item => (
                    <TableRow key={ item.id }>
                        <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}> 
                            <Checkbox color="primary" checked={isSelected(item.id)} onChange={() => handleClick(item.id)} />
                        </TableCell>
                        <TableCell>
                            {item.op?.fechaEntrega 
                            ?   fechaSinHora(item.op.fechaEntrega)
                            :   <span style={{ color:'red' }}>No-Dato</span>
                            }
                        </TableCell>
                        <TableCell>{ item?.op?.op }</TableCell>
                        <TableCell>{ item.producto.nombre }</TableCell>
                        <TableCell>{ item?.op?.quienCompra?.nombre }</TableCell>
                        <TableCell>{ item.area }</TableCell>
                        <TableCell>
                            <Chip label={item?.op?.pago} sx={{ fontWeight:500, minWidth:80, color:'white' }}
                                color={item?.op?.pago === 'REALIZADO' ? 'success' : 'error'} size="small"
                            />
                        </TableCell>
                        <TableCell>
                            <Stack direction="row" spacing={1} justifyContent="center">
                                <TooltipAndIcon
                                    titulo="Detalles Items"
                                    icono="ver"
                                    color="white"
                                    onClick={() => navigate(`/super/dt-pro-op/${item.id}`)}
                                />  

                                <TooltipAndIcon
                                    titulo="Ver Trasabilidad"
                                    icono="trasabilidad"
                                    color="white"
                                    onClick={() => navigate(`/super/registro/${ item.id }/items`)}
                                />  
                            </Stack>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>

            </LayoutTabla>
        
        :   <MensajeAlertaDanger titulo='No hay ops disponibles' />
        }
        </>


    )
}
